import { parseTimeWithFormats } from '~/utils/parseTimeWithFormats'

const twentyFourHourFormats = ['HH:mm', 'H:mm', 'HH:mm:ss', 'H:mm:ss'] as const

export const parseTwentyFourHour = (value: string) =>
  parseTimeWithFormats(value, twentyFourHourFormats)
